module.exports = __webpack_public_path__ + "media/C1.3c5745c9.mp3";